import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { Button, InputGroup, InputProps, InputRightElement } from "@chakra-ui/react";
import { FC, useState } from "react";
import { CustomInput } from "../CustomInput/CustomInput";

export type CustomPasswordInputProps = Omit<InputProps, "value" | "onChange"> & {
  value: string;
  onChange: (value: string) => void;
  leftIcon?: React.ElementType;
};

export const CustomPasswordInput: FC<CustomPasswordInputProps> = ({ value, onChange, placeholder, id, leftIcon }) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <InputGroup>
      <CustomInput
        leftIcon={leftIcon}
        placeholder={placeholder}
        h="48px"
        pr="48px"
        id={id}
        value={value}
        onChange={onChange}
        type={showPassword ? "text" : "password"}
      />
      <InputRightElement h="48px" w="48px">
        <Button
          size="sm"
          variant="ghost"
          color="gray.400"
          borderRadius="10px"
          onClick={() => setShowPassword(showPassword => !showPassword)}
          _hover={{ color: "primary", bg: "rgba(67,0,152,0.06)" }}
        >
          {showPassword ? <ViewIcon /> : <ViewOffIcon />}
        </Button>
      </InputRightElement>
    </InputGroup>
  );
};
